module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA1.413aea70.jpg";